A description type identifier.

This specifies the meaning of the description and determines where it's presented to the candidate.
